enum BiteLogWorldpayEvent {
  TerminalDisconnected = 1,
  UpdateIdleTextError = 2,
  TerminalRebootRequestSuccess = 3,
  TerminalRebootRequestError = 4,
  TerminalIdleTextRequestSuccess = 5,
  TerminalIdleTextRequestError = 6,
}

export { BiteLogWorldpayEvent };
